import { render, staticRenderFns } from "./tableValid.vue?vue&type=template&id=626d049b&scoped=true"
import script from "./tableValid.vue?vue&type=script&lang=js"
export * from "./tableValid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626d049b",
  null
  
)

export default component.exports